module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider-wrap"
  }, [_c('div', {
    ref: "track",
    staticClass: "slider__scrollable"
  }, [_c('div', {
    staticClass: "slider__track"
  }, _vm._l((_vm.slideList), function(slide, index) {
    return _c('slide', {
      directives: [{
        name: "touch",
        rawName: "v-touch:swipedown",
        value: (_vm.scrollUp),
        expression: "scrollUp",
        arg: "swipedown"
      }, {
        name: "touch",
        rawName: "v-touch:swipeleft",
        value: (_vm.nextSlide),
        expression: "nextSlide",
        arg: "swipeleft"
      }, {
        name: "touch",
        rawName: "v-touch:swiperight",
        value: (_vm.prevSlide),
        expression: "prevSlide",
        arg: "swiperight"
      }],
      key: index,
      ref: "slides",
      refInFor: true,
      class: {
        'is-active': _vm.currentSlide === index
      },
      attrs: {
        "indexSlide": index
      },
      on: {
        "slideClick": _vm.setSlide
      }
    }, [_c('router-link', {
      attrs: {
        "to": '/' + _vm.lang + slide.url
      }
    }, [(slide.epigraph) ? _c('div', {
      staticClass: "slide__label"
    }, [_vm._v(_vm._s(slide.epigraph))]) : _vm._e(), _c('h2', {
      staticClass: "slide__title"
    }, [_vm._v(_vm._s(slide.name))]), _c('div', {
      staticClass: "slide__marker marker"
    }, [_c('div', {
      staticClass: "marker__bar"
    }), _c('div', {
      staticClass: "marker__dot"
    })])])], 1)
  }))]), _c('transition-wrapper', {
    attrs: {
      "appear": true
    }
  }, [_c('dots', {
    staticClass: "footer-slider__navigation",
    attrs: {
      "items": _vm.slideList,
      "current": _vm.currentSlide,
      "inverted": true
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f16c3a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider/slider.vue
// module id = 496
// module chunks = 0